import { registerPlugin } from '@capacitor/core';

export interface SsoAuthResult {
    url: string;
}

export interface SsoAuthPlugin {
    start(opts: {
        url: string,
        callbackHost: string,
        callbackPath: string
    }): Promise<SsoAuthResult>;
}

const Auth = registerPlugin<SsoAuthPlugin>('Auth')

export { Auth };